import {ElMessage,ElMessageBox} from 'element-plus'

// 用来显示各种消息提示


/**
 * 成功消息提示
 * @param msg
 */
function successMsg(msg){
    ElMessage({
        message: msg,
        type: 'success',
    })
}

/**
 * 错误消息提示
 * @param msg
 */
function errorMsg(msg){
    ElMessage({
        message: msg,
        type: 'error',
    })
}




export default {successMsg,errorMsg,ElMessageBox}
